<template>
  <div class="wrap" v-cloak>
    <div class="background">
      <div class="back">
        <!-- 选项 -->
        <div class="tab">
          <div class="left">发布单位：</div>
          <el-radio-group
            v-model="radio1"
            fill="#2967de"
            @change="changeReportLevel1($event)"
          >
            <el-radio-button label="全部"></el-radio-button>
            <el-radio-button label="科技"></el-radio-button>
            <el-radio-button label="工信"></el-radio-button>
            <el-radio-button label="发改"></el-radio-button>
          </el-radio-group>
        </div>
        <div class="tab">
          <div class="left">所属地区：</div>
          <el-radio-group
            v-model="radio2"
            fill="#2967de"
            @change="changeReportLevel2($event)"
          >
            <el-radio-button label="全部"></el-radio-button>
            <el-radio-button label="国家级"></el-radio-button>
            <el-radio-button label="省级"></el-radio-button>
            <el-radio-button label="郑州"></el-radio-button>
          </el-radio-group>
        </div>
        <!-- 内容 -->
        <el-empty
          v-if="!isShows"
          style="transform: translate(-380px, 120px)"
          description="没有相关数据"
        ></el-empty>
        <ul v-show="isShows">
          <li
            class="content"
            v-for="data in policyData"
            :key="data.policy_id"
            @click="openWindow(data.policy_id)"
          >
            <div class="text1">
              <div class="img" v-if="data.issued == '科技'">
                <img src="../assets/img/keji.png" alt="" />
              </div>
              <div class="img" v-if="data.issued == '工信'">
                <img src="../assets/img/gongxin.png" alt="" />
              </div>
              <div class="img" v-if="data.issued == '发改'">
                <img src="../assets/img/fagai.png" alt="" />
              </div>
            </div>
            <div class="text2">
              <div style="margin-bottom: 15px; text-align: left">
                <span class="title">{{ data.title }}</span>
                <!-- <span style="width: 36px;height: 16px;background: #fff4e2;border-radius: 5px;color: #FF7E28;padding: 5px;">国家级</span> -->
              </div>
              <div
                style="font-size: 15px; margin-bottom: 15px; text-align: left"
              >
                <span style="margin-right: 20px"
                  >发布单位:{{ data.issued }}</span
                >
                <span>行业:{{ data.industry }}</span>
              </div>
              <div style="line-height: 20px; color: #979b9f; text-align: left">
                <dd
                  class="box"
                  v-html="data.declare_condition"
                  style="margin-left: 0"
                >
                  {{ data.declare_condition }}
                </dd>
                <!-- 科技型中小企业是指依托一定数量的科技人员从事科学技术研究开发活动，取得自主知识产权并将其转化为高新技术产品或服务，从而实现可持续发展的中小企业。 -->
              </div>
            </div>
            <!-- 按钮 -->
            <el-button
              type="primary"
             
              class="zctj"
              >政策体检</el-button
            >
          </li>
          <!-- 分页 -->
          <el-pagination
            v-show="isShows"
            class="fenye"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="count"
            layout="total, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </ul>
      </div>
    </div>

    <!-- 弹窗 -->
    <message
      v-if="isShow"
      @closeWindow="closeWindow"
      :policy_id="policy_id"
      :companyName="companyName"
    ></message>
  </div>
</template>

<script>
import message from "@/views/message.vue";
import axios from "axios";
export default {
  components: {
    message,
  },
  data() {
    return {
      userid:"",
      policy_id: "",
      radio1: "全部",
      radio2: "全部",
      isShow: false,
      qyname: "",
      qylable: "",
      total: 0,
      count: 0,
      policyData: [],
      currentPage: 1,
      isShows: true,
      companyName:""
    };
  },
  mounted: function () {
    this.$nextTick(function () {
      this.userid = localStorage.getItem("RealID");
      //this.userid="10835";
      if(this.userid !="" && this.userid != null && this.userid !="null" && this.userid != undefined && this.userid != "undefined"){
          this.getCompany();
      }
      this.policy(1, "", "");
    });
  },
  methods: {
    policy(pageno, issued, area) {
      axios({
        method: "get",
        url: "http://1.192.121.29:9000/api/nttzzc/policy",
        params: {
          search: "",
          issued: issued,
          area: area,
          page_no: pageno,
          limit: "5",
        },
      })
        .then((response) => {
          var json = response.data;
          if (json.hasOwnProperty("msg")) {
            this.isShows = false;
          } else {
            this.total = json.total;
            this.count = 5;
            this.policyData = json.data;
            this.isShows = true;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getCompany() {
      axios({
        method: "get",
        url: "http://124.70.78.125:8082/WebService/Organization.ashx",
        params: {
          UnitName: this.userid,
          action: "Get_Organization",
        },
      })
        .then((response) => {
          var json = response.data;
          if (json.Code == "200") {
            var s1 = [];
            s1 = JSON.parse(json.Data);
            this.companyName = s1[0].UnitName;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleSizeChange(val) {
      this.currentPage = val;
      this.policy(val, this.radio1, this.radio2);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.policy(val, this.radio1, this.radio2);
      this.scrollTop(".wrap");
    },
    changeReportLevel1(el) {
      this.radio1 = el;
      this.policy(1, this.radio1, this.radio2);
    },
    changeReportLevel2(el) {
      this.radio2 = el;
      this.policy(1, this.radio1, this.radio2);
    },
    openWindow(id) {
      let RealName = localStorage.getItem("RealName");
      //RealName = "123"
      let vm = this;
      if (RealName == "") {
        vm.$confirm("当前未登录, 是否登录?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$bus.$emit("dialogVisible", "true");
          })
          .catch(() => {});
      } else {
        this.policy_id = id;
        this.isShow = true;
      }
    },
    closeWindow() {
      this.isShow = false;
    },
    scrollTop(selector) {
      let element = (selector && document.querySelector(selector)) || window;
      element.scrollTo(0, 0);
    },
  },
};
</script>

<style lang="scss" scoped>
[v-cloak] {
  display: none;
}

.wrap {
  margin: auto;
  height: 100%;
  //height: 55.4375rem;
  overflow-x: hidden;
  .background {
    width: 100%;
    height: 1680px;
    background: url(../assets/img/底色.png);
    background-repeat: no-repeat;
    background-size: 85% 102%;
    margin-left: 8%;

    .back {
      padding-left: 160px;
      padding-top: 180px;

      .tab {
        font-size: 18px;
        font-weight: 600;
        display: flex;
        margin-bottom: 20px;

        .left {
          padding-top: 8px;
          margin-right: 10px;
        }
      }
    }

    .content {
      width: 75%;
      margin-top: 40px;
      display: flex;
      background-color: #fff;
      box-shadow: 0px 0px 10px 0px rgba(150, 152, 157, 0.2);
      transform: translateX(-30px);
      .text1 {
        padding: 27px;
        padding-bottom: 0px;
        margin-right: 5px;
        padding-right: 20px;
        img {
          max-width: 180px;
        }
      }

      .text2 {
        width: 62%;
        padding: 40px 0 20px 0;
        padding-bottom: 0;
        .title {
          font-size: 20px;
          color: #2967de;
          font-weight: 600;
          margin-right: 12px;
        }
      }
    }

    .box {
      height: 90px;
      position: relative;
      overflow: auto;
    }

    .zctj {
      height: 50px;
      font-size: 17px;
      background-color: #2967de;
      margin-top: 78px;
      margin-left: 6%;
      margin-right: 25px;
      padding: 13px 13px;
      border-radius: 7px;
    }
  }

  .fenye {
    margin-top: 3%;
    margin-left: 18%;
    text-align: left;
  }
}
</style>